'use client';

import type { FC } from 'react';
import { useRouter } from 'next/navigation';

import {
    Select,
    SelectContent,
    SelectItem,
} from '@/components/molecules/Select';

import type { SelectMenuType } from './SelectMenu.types';

export interface SelectMenuProps {
    config: SelectMenuType;
}

const SelectMenu: FC<SelectMenuProps> = ({ config }) => {
    const router = useRouter();

    const handleValueChange = (value: string) => {
        const selectedItem = config.mobileList.find(item => item.id === value);

        if (selectedItem) {
            router.push(selectedItem.href);
        }
    };

    return (
        <Select
            placeholder={config.placeholder}
            className="md:!hidden"
            onValueChange={handleValueChange}
        >
            <SelectContent>
                {config.mobileList.map(({ id, name }) => (
                    <SelectItem
                        key={id}
                        value={id}
                        data-test-id={`section-integration-side-mobile-category-${id}`}
                    >
                        <span className="text-sm font-extrabold">{name}</span>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default SelectMenu;
